import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { BatchPutTemplate } from '../BatchGet';
import { TabPanel } from '@mui/lab';
export const BatchPutExample = ({ value }) => {
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "1. Batch Put" }), _jsx(BatchPutTemplate, {})] }, 'batchPut'));
};
